import type { QuickStepAction } from 'owa-mail-quick-steps-store/lib/store/schema/QuickStepAction';
import type { QuickStepActionType } from 'owa-mail-quick-steps-store/lib/store/schema/QuickStepActionType';
import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import { MenuItemType } from 'owa-filterable-menu';

const shouldEnableMap = getMailMenuItemShouldShowMap();

export function getIsQuickStepDisabled(actions: QuickStepAction[]): boolean {
    // If any one of our actions is disabled, this quick step should be disabled
    for (let i = 0; i < actions.length; i++) {
        if (!shouldEnableMap[getCmdIdFromActionType(actions[i].type)]()) {
            return true;
        }
    }
    return false;
}

function getCmdIdFromActionType(type: QuickStepActionType) {
    // It's possible the map doesn't contain the type, if so return the bad item type
    return ActionTypeToCmdIdMap.get(type) ?? MenuItemType.BadItemType;
}

const ActionTypeToCmdIdMap: Map<QuickStepActionType, MenuItemType> = new Map<
    QuickStepActionType,
    MenuItemType
>([
    ['markAsRead', MenuItemType.Ribbon_ReadUnread],
    ['markAsUnread', MenuItemType.Ribbon_ReadUnread],
    ['delete', MenuItemType.Ribbon_Delete],
    ['moveTo', MenuItemType.MoveMessage],
    ['copyTo', MenuItemType.MoveMessage],
    ['category', MenuItemType.Categories],
    ['clearCategories', MenuItemType.Categories],
    ['forwardTo', MenuItemType.Ribbon_Forward],
    ['forwardAsAttachment', MenuItemType.Ribbon_Forward],
]);
